import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
// redux
import { useSelector } from '../redux/store';
// @types
import { VenueManager } from '../@types/venue';

// ----------------------------------------------------------------------

export type TenantMode = 'organization' | 'venue';

/**
 * Derives the current org-wide vs. single-venue context from `tenantVenue`,
 * plus the accent color used consistently to signal that mode across the UI
 * (header stripe, popover, per-page context chips).
 */
export default function useTenantMode() {
  const theme = useTheme();
  const { tenantVenue, venues } = useSelector((state) => state.venue);

  return useMemo(() => {
    const isVenueMode = typeof tenantVenue === 'object' && tenantVenue !== null;
    const mode: TenantMode = isVenueMode ? 'venue' : 'organization';
    const venue = isVenueMode ? (tenantVenue as VenueManager) : null;
    const color = isVenueMode ? theme.palette.info.main : theme.palette.primary.main;

    return {
      mode,
      isVenueMode,
      isOrganizationMode: !isVenueMode,
      venue,
      color,
      venueCount: venues.length,
    };
  }, [tenantVenue, venues.length, theme]);
}
